import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ContentService } from '@common/services/content.service';
import { naturalSort } from '@enus/utils/natural-sort';

@Component({
    selector: 'app-partner-list',
    templateUrl: './partner-list.component.html',
    styleUrls: ['./partner-list.component.scss'],
    standalone: false
})
export class PartnerListComponent implements OnInit {
    
    @Input()
    titleKey: string;

    @Input()
    cmsKey: string;

    @Input()
    showEnvironmentTexasLogo = false;

    logosCmsKeys$: Observable<string[]>;

    constructor(
        public contentService: ContentService
    ) { }

    ngOnInit() {
        
        this.logosCmsKeys$ = this.contentService.filter((key) => key.startsWith(this.cmsKey))
            .pipe(
                map(contentArr => contentArr.map(content => content.key)),
                map(keys => naturalSort(keys))
            );
    }
}
